import { EmptyState } from "@/components/shared";
import { Users, KeyRound, Trash2, Crown } from "lucide-react";

export const UsersTab = ({ users, loading, onResetPw, onDelete, onToggleMaster }) => {
  if (loading) return <div className="h-40 bg-white border border-line rounded-xl animate-pulse" />;
  if (users.length === 0) return <div className="bg-white border border-line rounded-xl"><EmptyState icon={Users} title="No users" /></div>;
  return (
    <div className="bg-white border border-line rounded-xl divide-y divide-line overflow-hidden">
      {/* Column header — desktop only */}
      <div className="hidden md:flex items-center gap-3 bg-bone text-mute text-sm px-4 py-3">
        <div className="flex-1 font-medium">User</div>
        <div className="w-40 font-medium">Role</div>
        <div className="w-28 font-medium">Owns</div>
        <div className="font-medium ml-auto">Actions</div>
      </div>

      {users.map((u) => (
        <div key={u.id} data-testid={`admin-user-${u.id}`} className="px-4 py-3 flex flex-col md:flex-row md:items-center gap-3 hover:bg-bone/50">
          {/* User */}
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <img src={u.avatar} alt="" className="h-9 w-9 rounded-full shrink-0" />
            <div className="min-w-0">
              <p className="font-medium text-ink truncate">{u.name}</p>
              <p className="text-xs text-mute truncate">{u.email}</p>
            </div>
          </div>

          {/* Role */}
          <div className="md:w-40 flex items-center gap-2 flex-wrap">
            <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold border capitalize ${u.role === "admin" ? "bg-ink text-white border-ink" : u.role === "landlord" ? "bg-forest/10 text-forest border-forest/20" : "bg-stone-100 text-stone-600 border-stone-200"}`}>{u.role}</span>
            {u.master_landlord && <span data-testid={`master-badge-${u.id}`} className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold border border-amber-300 bg-amber-50 text-amber-700 uppercase"><Crown className="h-3 w-3" />Master Pro</span>}
          </div>

          {/* Owns */}
          <div className="md:w-28 text-mute text-sm">{u.role === "landlord" ? `${u.property_count} properties` : `${u.lease_count} leases`}</div>

          {/* Actions */}
          <div className="flex flex-wrap gap-2 md:justify-end md:ml-auto">
            {u.role === "landlord" && (
              <button data-testid={`master-toggle-${u.id}`} onClick={() => onToggleMaster(u)} className={`rounded-lg px-3 py-1.5 flex items-center gap-1 text-xs border ${u.master_landlord ? "border-amber-300 text-amber-700 bg-amber-50 hover:bg-amber-100" : "border-line hover:bg-bone"}`}><Crown className="h-3.5 w-3.5" /> {u.master_landlord ? "Remove Master" : "Make Master"}</button>
            )}
            <button data-testid={`reset-pw-${u.id}`} onClick={() => onResetPw(u)} className="border border-line rounded-lg px-3 py-1.5 hover:bg-bone flex items-center gap-1 text-xs"><KeyRound className="h-3.5 w-3.5" /> Password</button>
            {u.role !== "admin" && (
              <button data-testid={`delete-user-${u.id}`} onClick={() => onDelete(u)} className="border border-red-200 text-red-600 rounded-lg px-3 py-1.5 hover:bg-red-50 flex items-center gap-1 text-xs"><Trash2 className="h-3.5 w-3.5" /> Delete</button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
